















import {Component, Prop, Vue} from 'vue-property-decorator';
import JdhFieldStructure from "@/design-system/forms/shared/JdhFieldStructure.vue"

/**
 * @status stable
 * @published $next
 * @changelog $next Published.
 */
@Component({
    components: {JdhFieldStructure}
})
export default class JdsCheckboxGroup extends Vue {
    @Prop() label!: string
}
